import { RefObject, useRef, useState } from 'react'
import { Grid, IconButton } from '@mui/material'

import { PlusIcon } from 'src/assets/icons'

import useStyles from './styles'
import { MoreButton } from './more-button.component'
import { StubInputPopover } from './stub-input-popover.component'

interface IProps {
  isRound?: boolean
  handleImagesOpen: () => void
  inputRef: RefObject<HTMLInputElement>
}

export const Stub = function ({ isRound, handleImagesOpen, inputRef }: IProps) {
  const classes = useStyles({ isRoundImage: isRound })
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleImageStubClick = () => {
    inputRef.current?.click()
  }

  return (
    <>
      <div ref={anchorRef} className={classes.imageInputWrapper}>
        <IconButton onClick={handleImageStubClick} className={classes.imageIconButton}>
          <Grid className={classes.imageIconWrapper}>
            <PlusIcon className={classes.imageIcon} />
          </Grid>
        </IconButton>
        <MoreButton handleOpen={handleOpen} />
      </div>
      <StubInputPopover
        handleImagesOpen={handleImagesOpen}
        anchorRef={anchorRef}
        handleClose={handleClose}
        open={open}
      />
    </>
  )
}
